module.exports = __webpack_public_path__ + "svg/admin/2-fingers-blue.svg";